import * as React from 'react';

import { classNames } from '../lib/classNames';

import { Paragraph } from './Typography/Paragraph';

export interface IStrapProps {
  type: `info` | `warning` | `error` | `success` | `frozen` | `caution`;
  children: React.ReactNode;
  className?: string;
}

const classes = {
  info: `bg-paidniceGreen-500`,
  warning: `bg-orange-500`,
  error: `bg-red-500`,
  success: `bg-green-500`,
  frozen: `bg-blue-400`,
  caution: `bg-orange-50`,
};

const contentClasses = {
  caution: `text-orange-500`,
};

export function Strap({
  type,
  children,
  className,
}: IStrapProps) {
  return (
    <div className={
      classNames(
        `flex h-16 xl:h-12 2xl:h-10 items-center justify-center px-6  sm:px-8 lg:px-10`,
        classes[type],
        className,
      ) }
    >
      <Paragraph
        className={ classNames(
          `text-white text-center`,
          contentClasses[type],
        ) }
      >
        { children }
      </Paragraph>
    </div>
  );
}
